import React from "react";
import {ButtonOption} from "./AuthStyles";

export default function ButtonSocial({Icon, title, action}) {
   return (
      <ButtonOption onClick={action} as="div">
         <Icon width="1em" height="1em" className="icon" />
         {title} 
      </ButtonOption>
   );
}

export function ButtonSocialFb({Icon, children, action}) {
   return (
      <ButtonOption onClick={action} as="div">
         <Icon width="1em" height="1em" className="icon" />
         {children}
      </ButtonOption>
   );
}
